import css from "./ingredientRow.module.css";
import * as uuid from "uuid";
import React, { useState, useContext } from "react";
import UnitContext from "./store/unit-context";

function IngredientRow(props) {
  const unitContext = useContext(UnitContext);

  const measurements = ["x"];

  if (props.measurementType === "both") {
    measurements.push(...unitContext.bothSymbols());
  } else if (props.measurementType === "metric") {
    measurements.push(...unitContext.metricSymbols());
  } else if (props.measurementType === "imperial") {
    measurements.push(...unitContext.imperialSymbols);
  }

  const [selectedOption, setSelectedOption] = useState(props.item.unit);

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
    props.item.unit = event.target.value;
  };

  const [amount, setAmount] = useState(props.item.amount);

  function onChangeAmount(event) {
    const value = event.target.value.replace(/[^\.\/0-9 ]/g, "");

    setAmount(value);
    props.item.amount = value;
  }

  return (
    <div className={css.container}>
      <input
        id={"amount" + uuid.v4()}
        className={css.amountInput}
        placeholder="Enter amount"
        value={amount}
        onChange={onChangeAmount}
      />
      <select
        id={"unit" + uuid.v4()}
        value={selectedOption}
        onChange={handleChange}
        className={css.select}
      >
        {measurements.map((type) => (
          <option key={uuid.v4()} value={type}>
            {type}
          </option>
        ))}
      </select>
      <input
        id={"ingredient" + uuid.v4()}
        className={css.nameInput}
        placeholder="Enter ingredient"
        defaultValue={props.item.name}
        onChange={(state) => {
          props.item.name = state.target.value;
        }}
      />
    </div>
  );
}

export default IngredientRow;
